// extracted by mini-css-extract-plugin
export var copyableField = "_r5-4";
export var customerBadge = "_r5-0";
export var customerInfoTitle = "_r5-2";
export var details = "_r5-1";
export var dropdownContainer = "_r5-5";
export var dropdownImage = "_r5-6";
export var editAssigneeForm = "_r5-a";
export var editButton = "_r5-3";
export var email = "_r5-7";
export var hidden = "_r5-d";
export var input = "_r5-8";
export var saveButton = "_r5-b";
export var shopifyIcon = "_r5-c";
export var suggestionBadge = "_r5-e";
export var suggestionText = "_r5-f";
export var username = "_r5-9";